import { plugins } from '@citation-js/core';
import { format as mapBiblatex, formatBibtex as mapBibtex } from './entries.js';
import { format } from './bibtex.js';
import { format as formatBibtxt } from './bibtxt.js';

var factory = function factory(mapper, formatter) {
  return function (data) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var type = opts.type,
        _opts$format = opts.format,
        format = _opts$format === void 0 ? type || 'text' : _opts$format;
    data = mapper(data);

    if (format === 'object') {
      return data;
    } else if (plugins.dict.has(format)) {
      return formatter(data, plugins.dict.get(format), opts);
    } else {
      throw new RangeError("Output dictionary \"".concat(format, "\" not available"));
    }
  };
};

export default {
  bibtex: factory(mapBibtex, format),
  biblatex: factory(mapBiblatex, format),
  bibtxt: factory(mapBibtex, formatBibtxt)
};